module.exports = __webpack_public_path__ + "static/media/panda-yellow.2bc76e8b.png";